{
  "colorInputLabel": "{label}, {channelLabel}",
  "colorNameAndValue": "{name}: {value}",
  "colorPicker": "Farbwähler",
  "twoDimensionalSlider": "2D-Schieberegler"
}
